module.exports = __webpack_public_path__ + "img/southern-union-old.60e79aec.jpg";